<!--
    考卷预览
-->
<template>
    <div>
        <paper-view
            v-if="!isFiscan"
            :paperInfo="paperInfo"
            :topicData="topicData"
            @close="onPaperClose"
        >
        </paper-view>

        <fiscan-paper
            ref="fiscanPaper"
            v-model="fiscanPaper.show"
            :data="fiscanPaper.data"
            type="preview"
            :usage="2"
            @close="onPaperClose"
        />
    </div>
</template>

<script>
import {screenfull} from '@/utils';
import paperView from '@/components/Paper/PaperView';
import FiscanPaper from '@components/FiscanPaper';

export default {
    props: ['paperId'],
    components: {
        paperView,
        FiscanPaper
    },
    data() {
        return {
            paperInfo: {},
            topicData: [],
            fiscanPaper: {
                show: false,
                data: null,
            },
            isFiscan: this.$route.query.isFiscan
        }
    },
    created() {
        if (this.isFiscan) {
            this.loadFiscanPaper()
        } else {
            this.loadTheoryPaper()
        }
    },
    methods: {
        loadFiscanPaper() {
            const data = this.$route.params.data;

            this.fiscanPaper.show = true

            if (this.paperId) {
                this.$api.getFiscanPaperDetail(this.paperId).then(res => {
                    this.fiscanPaper.data = res.package
                }).catch(() => {this.fiscanPaper.show = false})

            } else if (data) {
                setTimeout(() => {
                    this.fiscanPaper.data = data
                }, 300)
            }
        },

        loadTheoryPaper() {
            const data = this.$route.params.data;

            if (this.paperId) {
                this.$api.getTheoryPaperDetail(this.paperId).then(res => {
                    console.log('res.package: ', res.package);
                    this.paperInfo = res.package;
                    this.topicData = res.package.relationship;
                }).catch(error => {
                    screenfull.exit();
                    history.go(-1);
                })
            } else if (data) {
                this.paperInfo = data;
                this.topicData = data.relationship;
            }
        },

        onPaperClose() {
            history.go(-1);
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../../style/const';
</style>
